module.exports = __webpack_public_path__ + "static/media/more.b2547f22.svg";